module.exports = __webpack_public_path__ + "static/media/handlopex.537a2900.png";